'use strict'

const firstChild = $(document).find('.l-blog-page-grid_container .l-blog-page-content_tile:first-child');
firstChild.removeClass('col-md-6').removeClass('col-lg-5');
firstChild.addClass('text-center');
firstChild.find('.col-12').removeClass('col-md-6');